const useFormPlayground = () => {
    const handleSubmit = (val: any) => {}
    return {
        onSubmit: handleSubmit,
    }
}

export default useFormPlayground
